<template>
  <div id="foots" class="foots">
    <div class="container">
      <div class="footer-top">
        <div class="footer-top-item head-item">
          <img :src="basicInfo.logo?basicInfo.logo:'../../assets/logo-litter.png'" alt/>
        </div>
        <div class="footer-top-item">
          <div class="tel">
            <div class="tel-top">服务热线 {{basicInfo.serviceTime}}</div>
            <div class="tel-bottom">{{loactionCityPhone}}</div>
          </div>
        </div>
        <div class="footer-top-item contactUs">
            <el-input  v-model="form.mobile" placeholder="联系电话" style="display:inline"></el-input>
        </div>
        <div class="footer-top-item contactUs">
          <div class="sendCode">
            <el-input  v-model="form.verificationCode" placeholder="输入验证码" style="display:inline"></el-input>
            <span>短信验证</span>
          </div>
        </div>
        <div class="footer-top-item contactUs">
          <div class="yellow-button" style="margin-top:4px;">
            <button class="">免费定制方案</button>
          </div>
        </div>
      </div>
      <div class="footer-middle">
        <div class="footer-middle-item">
          <div>服务导航</div>
          <div class="footer-middle-item-line1"></div>
          <div class="footer-middle-item-line2"></div>          
          <ul>
            <li @click="tonav(1)">团建产品</li>
            <li @click="tonav(2)">年会产品</li>
            <li @click="tonav(3)">企业内训</li>
            <li @click="tonav(4)">客户案例</li>
          </ul>
        </div>
         <div class="footer-middle-item">
          <div>热门玩法</div>
          <div class="footer-middle-item-line1"></div>
          <div class="footer-middle-item-line2"></div>
          <ul v-if="playTypeInfo">
            <li v-for="item in playTypeInfo" :key="item.id" @click="gotoTeamBuilding(item.id)">{{item.name}}</li>
          </ul>
        </div>
        <div class="footer-middle-item">
          <div>联系我们</div>
          <div class="footer-middle-item-line1"></div>
          <div class="footer-middle-item-line2"></div>          
          <ul>
            <li @click="tonav(5)">关于蓝星球</li>
            <li @click="tonav(6)">商务合作</li>
            <li class="email"><a :href="basicInfo.email">加入我们</a></li>
            <li class="light">{{basicInfo.email}}</li>
            <li class="company">{{basicInfo.companyName}} </li>
          </ul>
        </div>
        <div class="footer-middle-item footer-middle-last-item">
          <div>关注我们</div>
          <div class="footer-middle-item-line1"></div>
          <div class="footer-middle-item-line2"></div>          
          <div class="contact" v-if="basicInfo.wxNo">
            <div  
                 v-for="item in basicInfo.wxNo"
                :key="item">
            <img :src="item?item:'../../assets/wxqrcode.jpg'"/>
            <span>公众号</span>
            </div>
              <!-- <div>
              <img src="../../assets/wxqrcode.jpg"/>
              <span>公众号</span>
              </div> -->
          </div>
        </div>                       
      </div>

      <div class="footer-bottom" @click="toLink">
        <div class="left">
          <!-- <a href="" target="_blank">{{basicInfo.beian}}</a>| -->
          <a href="" target="_blank">{{basicInfo.beian}}<img src="../../assets/badge.png" alt=""/></a>
        </div>
        <div class="right">{{basicInfo.companyName}} copyright © 2019-2021</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import {handlePicPlusPre} from "../../util/util";
export default {
  name: "foots",
  data() {
    return {
      systems: "",
      webList: "",
      systemsName: "",
      webListName: "",
      serviceTime: "",
      servicePhone: "",
      form:{
        mobile:'',
        verificationCode:'',
      },
      // 服务热线
      servicePhone:'13172094444',
      // 服务时间
      serviceTime:'09:00-13:00',      
    };
  },
  computed: {
    basicInfo() {
      return this.$store.state.webInfo;
    },
    playTypeInfo() {
      return this.$store.state.playTypeList;
    },
    loactionCityPhone() {
      return this.$store.state.locationCityPhone?this.$store.state.locationCityPhone:this.$store.state.webInfo.servicePhone;
    },
  },
  methods: {
    handlePicPlusPre,
    tonav(index) {
      if (index == 1) {
        this.$router.push({ path: `/teamBuilding` });
      } else if (index == 2) {
        this.$router.push({ path: `/annualMeetingPage` });
      }else if (index == 3) {
        this.$router.push({ path: `/internalTrainingList` });
      }else if (index == 4) {
        this.$router.push({ path: `/caseList` });
      }else if (index == 5){
        this.$router.push({ path: `/aboutUs` });
      }else if (index == 6) {
        this.$router.push({ path: `/cooperation` });
      }
    },
    gotoTeamBuilding(playTypeId){
        this.$router.push({ path: `/teamBuilding`,query: { playTypeId: playTypeId }, });
    },
    toLink() {
      window.open("http://beian.miit.gov.cn");
    },
    handleSystems(command) {
      console.log("click on item " + command);
    },
    handleWebList(command) {
      console.log("click on item " + command);
    },
    //友情链接
    getLink() {
      axios.get(`/mobile/cmFriendLink/getFriendLink.jhtml`).then(res => {
        if (res.data.success) {
          this.systems = res.data.output.systems;
          this.webList = res.data.output.webList;
          this.systemsName = res.data.output.systems[0].name;
          this.webListName = res.data.output.webList[0].name;
        } else {
          this.$message("系统繁忙，请稍后再试~");
        }
      });
    }
  },
  mounted() {
    // this.getLink();
  }
};
</script>

<style scoped>
.foots {
  position: relative;
  
  background: #333333;
  font-size: 14px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}





.footer-bottom {
  border-top: 1px solid #ccc;
  margin-top: 15px;
  padding-top: 15px;
  cursor: pointer;
  color: #959595;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
}

.footer-bottom .left a{
  color: #959595;
}
.footer-bottom .left img {
    height: 14px;
    transform: translate(1px,2px);
}
.el-dropdown-menu {
  /* width: 150px; */
}
/* middle*/
.container .footer-middle{
    flex-direction: row;
    flex-wrap: nowrap;
    display: flex;
    align-content: space-between;
    padding: 20px  0px 10px 0px;
}
.container .footer-middle .footer-middle-item{
  flex: 1;
  text-align: left;
}
.container .footer-middle .footer-middle-item div{
    font-size: 16px;
    color: #fff;
    font-weight: 700;
}

.container .footer-middle .footer-middle-item  ul{
  padding: 10px 0 0 10px;
}
.container .footer-middle .footer-middle-item  ul li{
    font-size: 14px;
    color: #959595;
    line-height: 26px;
    list-style: none;
    width:fit-content;
    cursor: pointer;
}
.container .footer-middle .footer-middle-item  ul .light {
    font-size: 14px;
    color: #ffffff;
    line-height: 26px;
    list-style: none;
    width:fit-content;
    cursor: pointer;
}
.container .footer-middle .footer-middle-item  ul .light:hover{
    color: #ffffff;
}
.container .footer-middle .footer-middle-item  ul .email a{
    font-size: 14px;
    color: #959595;
    line-height: 26px;
    list-style: none;
    width:fit-content;
    cursor: pointer;
}
.container .footer-middle .footer-middle-item  ul .email a:hover{
    color: #359FF8;
}
.container .footer-middle .footer-middle-item  ul .company{
    font-size: 12px;
    line-height: 22px;
}
.container .footer-middle .footer-middle-item  ul .company:hover{
    color: #959595;
    font-size: 12px;
    line-height: 22px;
}
.container .footer-middle .footer-middle-item  ul .light:before{
    content: ".";
    opacity: 0;
    font-size: 14px;
}
.container .footer-middle .footer-middle-item  ul li:before{
    content: "∙";
    color: inhert;
    font-size: 14px;
}
.container .footer-middle .footer-middle-item  ul li:hover{
    font-size: 14px;
    color: #359FF8;
    line-height: 26px;
    list-style: none;
    cursor: pointer;
}
.container .footer-middle .footer-middle-item  .contact{
    flex-direction: row;
    flex-wrap: nowrap;
    display: flex;
    padding-top: 20px;
    
}
.container .footer-middle .footer-middle-item .contact div {
    flex: 1;
    display: flex;
    flex-direction: column;
}
.container .footer-middle .footer-middle-item  .contact span{
    display: inline-block;
    font-size: 12px;
    color: #959595;
    margin-top: 5px;
    text-align: center;
    width: 100px;
}
.container .footer-middle .footer-middle-item  .contact img{
    width: 100px;
    height: 100px;
    border-radius: 10px;
}
/* top */
.container .footer-top {
    border-bottom: 1px solid #2f3031;
    margin: 0 auto;
    padding-bottom: 20px;
    flex-direction: row;
    flex-wrap: nowrap;
    display: flex;
    padding-top: 56px;
}
.container .footer-top .footer-top-item{
    flex: 2;
    padding-left: 10px;
}
.container  .footer-top .footer-top-item img {
    height: 54px;
}
.container .footer-top .footer-middle-item  .contact img{
    width: 100px;
    height: 100px;
    border-radius: 10px;
}
.tel{
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 700;
  padding-right: 0px;
  padding-left: 0px;
  margin-top: 5px;
}
.tel .tel-top{
  line-height: 30px;
  font-size: 12px;
  color: #fff;
  line-height: 20px;
  width: 100%;
  margin-right: 81px;
} 
.tel .tel-bottom{
  line-height: 30px;
  font-size: 16px;
  color: #359FF8;
  line-height: 20px;
  font-family: Arial-Black;
} 
.footer-top-item .yellow-button{
    width: 100%;
    position: relative;
    font-weight: 700;
    font-size: 16px;
    color: #fff;
    letter-spacing: 1.6px;
    text-align: center;
    border-radius: 2px;
    height: 44px;
    background: #359FF8;
    border-radius: 6px;
    margin-top: 4px;
}
.footer-top-item .yellow-button button{
    color: #222;
    font-weight: 700;
    outline: none;
    background: none;
    border: none;
    width: 100%;
    height: 100%;
    cursor: pointer;
}
.sendCode{
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin-top: 5px;
  border: #cccccc 1px solid;
  background: transparent;
  border-radius: 6px;
}
.sendCode >>> .el-input__inner {
    border: none; 
    border-color: transparent ;
    background: fixed;
    width: 150px!important;
    color:#359FF8;
    margin-top: 0px!important;
}
.sendCode span{
    flex-shrink: 0;
    display: inline-block;
    font-size: 14px;
    text-align: center;
    color: #359FF8;
    cursor: pointer;
    width: 90px;
    
    
}
.footer-top-item >>> .el-input__inner {
    border-color: #cccccc ;
    background: transparent;
    width:200px;
    color: #359FF8 !important;;
    margin-top: 5px;
    height: 40px!important;
}
  .container {
  width:1060px!important;
  /* display: flex;
  flex-direction: column;
  justify-content: center; */
  }
  .container .footer-top .head-item{
  padding-left: 0px!important;
  flex: 1!important;
  }
  .container .footer-middle .footer-middle-last-item{
  /* margin-right: 20px!important; */
  margin-left: 30px;
  }
  .footer-middle-item-line1{
    border-bottom: #359FF8 solid 1px;
    width: 20px;
    margin-bottom: 5px;
    margin-top: 7px;
  }
  .footer-middle-item-line2{
   
    border-bottom: #359FF8 solid 1px;
    width: 30px;
  }
  .contactUs{
    opacity: 0;
  }
</style>
<style>
/* @media screen and (min-width: 1920px) {
  .container {
  width:1400px!important;
  }
}
@media screen and (min-width: 1720px) {
  .container {
  width:70%!important;
  }
}
@media screen and (min-width: 762px) {
  .container {
  width:40%!important;
  }
} */

</style>



// WEBPACK FOOTER //
// src/components/comment/homeFoots.vue